// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f3652a39","453":"09fd8694","455":"4437e135","558":"013265f8","977":"5d04db2b"}[chunkId] + ".chunk.js";
};